import { AvatarCreator } from "@readyplayerme/react-avatar-creator";
import i18next from "i18next";

const style = { width: "100%", height: "100%", border: "none" };

export default function AvatarCreatorV2(props) {
  const config = {
    clearCache: false,
    bodyType: "fullbody",
    quickStart: false,
    language: i18next.language.substring(0, 2).toLowerCase(),
  };

  const handleOnAvatarExported = (event) => {
    props.setAvatarInformations(event.data.url);
  };

  return (
    <>
      <AvatarCreator
        subdomain="fanartzone"
        config={config}
        style={style}
        onAvatarExported={handleOnAvatarExported}
      />
    </>
  );
}
